import React, { useState } from 'react';
import { IonIcon } from '@ionic/react';
import { imageOutline } from 'ionicons/icons';

type Props = { src?: string; nome: string };

const ProdutoImagemPreview: React.FC<Props> = ({ src, nome }) => {
  const url = typeof src === 'string' ? src.trim() : '';
  const [urlComFalha, setUrlComFalha] = useState<string | null>(null);
  const nomeProduto = nome || 'produto sem nome';
  const indisponivel = !!url && urlComFalha === url;
  const texto = indisponivel ? 'Foto indisponível' : 'Sem foto';

  return <div className="uploadia-product-photo">
    {url && !indisponivel ? <img src={url} alt={`Foto de ${nomeProduto}`} width={88} height={88}
      loading="lazy" decoding="async" onError={() => setUrlComFalha(url)} /> :
      <div className="uploadia-product-photo-placeholder" role="img" aria-label={`${texto}: ${nomeProduto}`}>
        <IonIcon icon={imageOutline} aria-hidden="true" />
        <span>{texto}</span>
      </div>}
  </div>;
};

export default ProdutoImagemPreview;
